import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayersBehind: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layers-behind, slides, pages"><path d="M2.75 19.25V6.75H21.25V19.25H2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 3.75H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLayersBehind;
